module.exports = __webpack_public_path__ + "media/Developer-Looping-Video.mp4";